module.exports = __webpack_public_path__ + "static/media/lakes.f2bf2fd2.svg";